/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancierShopsGroupInstallmentOption } from './FinancierShopsGroupInstallmentOption';
export type FinancierShopGroupInstallmentConditionCreateRequest = {
    name: string;
    isOpen: boolean;
    priority: number;
    osType: FinancierShopGroupInstallmentConditionCreateRequest.osType;
    productType: FinancierShopGroupInstallmentConditionCreateRequest.productType;
    minProductPurchaseCostAmount: number;
    maxProductPurchaseCostAmount: number;
    downPaymentAmountList: Array<number>;
    installmentCountList: Array<FinancierShopsGroupInstallmentOption>;
    commissionAmount: number;
    additionalCommissionAmount: number;
    shopAgentCommissionAmount?: number;
    contractFeeAmount: number;
    unlockingFeeAmount: number;
    requiredInstallmentCount: number;
};
export namespace FinancierShopGroupInstallmentConditionCreateRequest {
    export enum osType {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
        OTHERS = 'OTHERS',
    }
    export enum productType {
        ALL = 'ALL',
        NEW = 'NEW',
        USED = 'USED',
    }
}

